import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import App from './App.tsx';
import ProductGuide from './pages/ProductGuide.tsx';
import TreatmentGuide from './pages/TreatmentGuide.tsx';
import './index.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Router>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/product-guide" element={<ProductGuide />} />
        <Route path="/treatment-guide" element={<TreatmentGuide />} />
      </Routes>
    </Router>
  </StrictMode>
);
